import { Accident } from './accident';
import { Vehicle } from './vehicle';
import { BaseWithId } from './base';
import { marker } from '@biesbjerg/ngx-translate-extract-marker';
import { BaseWithIdList } from '@app/shared/models/list';
import { Office } from '@app/shared/models/office';
import { Workflow } from '@app/shared/models/workflow';

export enum CaseStatus {
    ALL = 'ALL'
}

export enum CasesFrom {
    ALL = 'ALL',
    MYCASES = 'MYCASES'
}

export class Case extends BaseWithId {
    public accident: Accident;
    public assessment_required: boolean;
    public assessor: string;
    public assessor_id: string;
    public case_no: string;
    public claim_date: Date;
    public claim_date_usertime: string;
    public claim_number: string;
    public claim_type: string;
    public claim_type_id: string;
    public client_id: string;
    public client_id2: string;
    public comment: string;
    public compensation_requested: boolean;
    public consecutive_number: number;
    public covered_insurance_types: string;
    public creation_date: Date;
    public flatrate: boolean;
    public insurance_covered_claim_type: string;
    public insurance_covered_claim_type_id: string;
    public insurance_number: string;
    public insurance_participation: number;
    public lawyer_required: boolean;
    public legal_protection: boolean;
    public tax_deduction: boolean;
    public office: string;
    public office_id: string;
    public perform_repair: boolean;
    public persons_injured: boolean;
    public police_present: boolean;
    public rental_car_needed: boolean;
    public reported_to_own_insurance: boolean;
    public reported_to_opposing_insurance: boolean;
    public state: string;
    public vehicle: Vehicle;
    public vehicle_financed: boolean;
    public vehicle_leased: boolean;
    public vehicle_towed: boolean;
    public workflow: Workflow;
    public contentstore_repository_model: 'JCR' | 'CEPH' | undefined;
    public requirement: string;
    public requirement_id: string;
    public contributory_fault: boolean;
    public business_trip: boolean;

    public readonly trans = {
        assessment_required: marker('case.assessment_required'),
        claim_date: marker('case.claim_date'),
        claim_date_usertime: marker('case.claim_date_usertime'),
        case_no: marker('case.case_no'),
        claim_number: marker('case.claim_number'),
        claim_type: marker('case.claim_type'),
        comment: marker('case.comment'),
        compensation_requested: marker('case.compensation_requested'),
        flatrate: marker('case.flatrate'),
        insurance_number: marker('case.insurance_number'),
        insurance_participation: marker('case.insurance_participation'),
        lawyer_required: marker('case.lawyer_required'),
        legal_protection: marker('case.legal_protection'),
        office: marker('case.office'),
        perform_repair: marker('case.perform_repair'),
        persons_injured: marker('case.persons_injured'),
        police_present: marker('case.police_present'),
        rental_car_needed: marker('case.rental_car_needed'),
        reported_to_own_insurance: marker('case.reported_to_own_insurance'),
        reported_to_opposing_insurance: marker('case.reported_to_opposing_insurance'),
        tax_deduction: marker('case.tax_deduction'),
        vehicle_financed: marker('case.vehicle_financed'),
        vehicle_towed: marker('case.vehicle_towed'),
        vehicle_leased: marker('case.vehicle_leased'),
        workflow: marker('case.workflow'),
        requirement: marker('case.requirement'),
        contributory_fault: marker('case.contributory_fault'),
        business_trip: marker('case.business_trip'),
    };

    constructor(json?: any) {
        super(json);
    }
 
    protected setObjectMappings(json: any): any {
        return Object.assign(super.setObjectMappings(json), {
            creation_date: json && json.creation_date ? new Date(json.creation_date) : null,
            claim_date: json && json.claim_date ? new Date(json.claim_date) : null,
            accident: new Accident(json && json.accident),
            vehicle: new Vehicle(json && json.vehicle),
            workflow: json && json.workflow ? Workflow.createSubType(json.workflow) : null
        });
    }
}

export interface CaseDialogData {
    case: Case;
    removeCancelBtn?: boolean;
    offices: BaseWithIdList<Office>;
    workflows?: BaseWithIdList<Workflow>;
}
